var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdmTrendPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#34485E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.352 12H16.648C13.736 12 12 13.736 12 16.648V23.352C12 26.264 13.736 28 16.648 28H23.352C26.264 28 28 26.264 28 23.352V16.648C28 13.736 26.264 12 23.352 12ZM18.376 22.32L16.576 24.12C16.456 24.24 16.304 24.296 16.152 24.296C16 24.296 15.84 24.24 15.728 24.12L15.128 23.52C14.888 23.288 14.888 22.904 15.128 22.672C15.36 22.44 15.736 22.44 15.976 22.672L16.152 22.848L17.528 21.472C17.76 21.24 18.136 21.24 18.376 21.472C18.608 21.704 18.608 22.088 18.376 22.32ZM18.376 16.72L16.576 18.52C16.456 18.64 16.304 18.696 16.152 18.696C16 18.696 15.84 18.64 15.728 18.52L15.128 17.92C14.888 17.688 14.888 17.304 15.128 17.072C15.36 16.84 15.736 16.84 15.976 17.072L16.152 17.248L17.528 15.872C17.76 15.64 18.136 15.64 18.376 15.872C18.608 16.104 18.608 16.488 18.376 16.72ZM24.448 23.696H20.248C19.92 23.696 19.648 23.424 19.648 23.096C19.648 22.768 19.92 22.496 20.248 22.496H24.448C24.784 22.496 25.048 22.768 25.048 23.096C25.048 23.424 24.784 23.696 24.448 23.696ZM24.448 18.096H20.248C19.92 18.096 19.648 17.824 19.648 17.496C19.648 17.168 19.92 16.896 20.248 16.896H24.448C24.784 16.896 25.048 17.168 25.048 17.496C25.048 17.824 24.784 18.096 24.448 18.096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdmTrendPrimary);
export default __webpack_public_path__ + "static/media/GDMTrendPrimary.38205342f7c1af6b335decc6f42a5c9a.svg";
export { ForwardRef as ReactComponent };